export default __webpack_public_path__ + "static/media/bg-navbar.da87cc5b.png";